<!---流水查询--->
<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="充值流水" name="list1">
        <list1 ref="list1">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" plain @click="onExport">导出</el-button>
            <el-button type="primary" @click="onCreate">新建</el-button>
          </template>
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column label="操作" fixed="right" align="center" width="60">
              <template slot-scope="{row}">
                <el-button v-if="!row.Online" type="text" @click="onDelete(row)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </list1>
      </el-tab-pane>
      <el-tab-pane label="消费流水" name="list2">
        <list2 ref="list2">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" plain @click="onExport">导出</el-button>
            <el-button type="primary" @click="onCreate">新建</el-button>
          </template>
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column label="操作" fixed="right" align="center" width="60">
              <template slot-scope="{row}">
                <el-button v-if="!row.Online" type="text" @click="onDelete(row)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </list2>
      </el-tab-pane>
      <el-tab-pane label="退款流水" name="list3">
        <list3 ref="list3">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" plain @click="onExport">导出</el-button>
          </template>
        </list3>
      </el-tab-pane>
      <el-tab-pane label="后台充值流水" name="list4">
        <list4 ref="list4">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" plain @click="onExport">导出</el-button>
          </template>
        </list4>
      </el-tab-pane>
      <el-tab-pane label="微信交易流水" name="list5">
        <list5 ref="list5">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" plain @click="onExport">导出</el-button>
          </template>
        </list5>
      </el-tab-pane>
      <el-tab-pane label="机器交易流水" name="list6">
        <list6 ref="list6">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" plain @click="onExport">导出</el-button>
          </template>
        </list6>
      </el-tab-pane>
    </el-tabs>
    <list1-dialog ref="list1Dialog" @close-saved="reload" />
    <list2-dialog ref="list2Dialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list1 from "@/components/xf/trading/list1/list";
import list1Dialog from "@/components/xf/trading/list1/editDialog";
import list2 from "@/components/xf/trading/list2/list";
import list2Dialog from "@/components/xf/trading/list2/editDialog";
import list3 from "@/components/xf/trading/list3/list";
import list4 from "@/components/xf/trading/list4/list";
import list5 from "@/components/xf/trading/list5/list";
import list6 from "@/components/xf/trading/list6/list";

export default {
  name: "trading",
  mixins: [curdMixins],
  components: {
    list1,
    list1Dialog,
    list2,
    list2Dialog,
    list3,
    list4,
    list5,
    list6,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      tabName: "list1",
    };
  },
  methods: {
    handleClick(e) {
      this.reload();
    },
    reload() {
      this.$refs[this.tabName].getData();
    },
    onExport() {
      this.$refs[this.tabName].onExport();
    },
    onCreate() {
      this.$refs[this.tabName + "Dialog"].openCreate();
    },
    onDelete(row) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs[this.tabName].onDelete(row);
        })
        .catch(() => {});
    },
  },
};
</script>